import ViewMain from 'views';
import ViewAuthentication from 'views/authentication';
import ViewApp from 'views/app';
import ViewError from 'views/error-page';

export const mainRoutes = [
  {
    name: 'slash',
    route: '/',
    component: <ViewMain />
  },
  {
    name: 'main',
    route: '',
    component: <ViewMain />
  },
  {
    name: 'Authentication',
    route: '/authentication/*',
    component: <ViewAuthentication />
  },
  {
    name: 'app',
    route: '/app/*',
    component: <ViewApp />
  },
  {
    name: 'error',
    route: `/*`,
    component: <ViewError />
  }
];
